import { Select } from 'antd'
import React, { useEffect } from 'react'
import { useListUsersQuery } from '../redux/Api/CustomerApiSlice'
import Loader from '../pages/pages/loader'
import { toast } from 'react-toastify'

const MultiCustomersDropdown = ({ onChange, onBlur, value, className = "", isAll = false }) => {
    const { data: customers, isLoading, error } = useListUsersQuery({
        expand: ['country', 'last_updated_by'].join(','),
        fields:['id','customer_name'].join(','),
        page: '*',
        ordering: 'customer_name'
    })

    let options

    if (customers) {
        options = customers?.results?.map(x => {
            return { label: x.customer_name, value: x.id }
        })
        if (isAll) {
            options = [{ label: "All Customers", value: "*" }, ...options]
        }
    }

    const handleChange = (selectedValues) => {
        const selectedCustomers = selectedValues.map(id => {
            return customers?.results?.find(customer => customer.id === id)
        })
        onChange(selectedCustomers) 
    }

    useEffect(() => {
        if (error?.data) {
            const errorMessages = Object.values(error.data).flat()
            errorMessages.forEach(message => {
                toast.error(message)
            })
        }
    }, [error])

    return (
        <div className="mb-3">
            <Loader isLoading={isLoading} />
            <label>Customers</label>
            <br />
            <Select
                className={className}
                name='customer'
                mode="multiple" 
                showSearch
                style={{
                    width: "100%"
                }}
                optionFilterProp="label"
                filterSort={(optionA, optionB) =>
                    (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                }
                value={value?.map(customer => customer.id)} 
                onChange={handleChange} 
                onBlur={onBlur}
                loading={isLoading}
                options={options}
            />
        </div>
    )
}

export default MultiCustomersDropdown
